/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} One_Off_PeriodInputs */

const en_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const id_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const ms_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const ca_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const cs_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const da_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const de_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const et_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const es_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const fr_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const hr_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const it_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const lv_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const lt_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const hu_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const nl_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const nb_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const pl_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const pt_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const ro_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const sk_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const sl_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const fi_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const sv_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const vi_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const tr_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const el_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const bg_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const ru_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const sr_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const uk_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const ka_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const hi_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const th_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const ko_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const zh_tw_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

const ja_one_off_period = /** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_period`)
};

/** @type {(inputs: One_Off_PeriodInputs) => LocalizedString} */
const zh_one_off_period = en_one_off_period;

/**
* | output |
* | --- |
* | "FIX one_off_period" |
*
* @param {One_Off_PeriodInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const one_off_period = /** @type {((inputs?: One_Off_PeriodInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<One_Off_PeriodInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_one_off_period(inputs)
	if (locale === "ms") return ms_one_off_period(inputs)
	if (locale === "ca") return ca_one_off_period(inputs)
	if (locale === "cs") return cs_one_off_period(inputs)
	if (locale === "da") return da_one_off_period(inputs)
	if (locale === "de") return de_one_off_period(inputs)
	if (locale === "et") return et_one_off_period(inputs)
	if (locale === "es") return es_one_off_period(inputs)
	if (locale === "fr") return fr_one_off_period(inputs)
	if (locale === "hr") return hr_one_off_period(inputs)
	if (locale === "it") return it_one_off_period(inputs)
	if (locale === "lv") return lv_one_off_period(inputs)
	if (locale === "lt") return lt_one_off_period(inputs)
	if (locale === "hu") return hu_one_off_period(inputs)
	if (locale === "nl") return nl_one_off_period(inputs)
	if (locale === "nb") return nb_one_off_period(inputs)
	if (locale === "pl") return pl_one_off_period(inputs)
	if (locale === "pt") return pt_one_off_period(inputs)
	if (locale === "ro") return ro_one_off_period(inputs)
	if (locale === "sk") return sk_one_off_period(inputs)
	if (locale === "sl") return sl_one_off_period(inputs)
	if (locale === "fi") return fi_one_off_period(inputs)
	if (locale === "sv") return sv_one_off_period(inputs)
	if (locale === "vi") return vi_one_off_period(inputs)
	if (locale === "tr") return tr_one_off_period(inputs)
	if (locale === "el") return el_one_off_period(inputs)
	if (locale === "bg") return bg_one_off_period(inputs)
	if (locale === "ru") return ru_one_off_period(inputs)
	if (locale === "sr") return sr_one_off_period(inputs)
	if (locale === "uk") return uk_one_off_period(inputs)
	if (locale === "ka") return ka_one_off_period(inputs)
	if (locale === "hi") return hi_one_off_period(inputs)
	if (locale === "th") return th_one_off_period(inputs)
	if (locale === "ko") return ko_one_off_period(inputs)
	if (locale === "zh") return zh_one_off_period(inputs)
	if (locale === "zh-tw") return zh_tw_one_off_period(inputs)
	if (locale === "ja") return ja_one_off_period(inputs)
	return en_one_off_period(inputs)
});